<div class="ltr" style="background: #F5F5F5; color: #9d9d9d;  padding-top: 40px; padding-bottom: 50px;">
  <div class="container">
    <h1 style="font-size: calc(30px + 1vw);">System's Style Guide</h1>
    <small class="d-none d-lg-block">(resize window in order to see mobile designs)</small>
  </div>
</div>
<div class="container">
  <div class="section ltr">
    <h2 class="title">Colors</h2>
    <div class="row">
      <div class="col-auto sub-section">
        <h6 class="sub-title">Color Codes & Var Names</h6>
        <div class="colors-grid">
          @for (color of colors; track color) {
            <div class="item d-flex flex-column align-items-center text-center">
              <div class="box" [class]="'app-'+color.names[0]+'-bg'"></div>
              <strong>{{color.code}}</strong>
              <ul class="list-unstyled">
                @for (name of color.names; track name) {
                  <li><i>${{name}}</i></li>
                }
              </ul>
            </div>
          }
        </div>
      </div>
      <div class="col-auto sub-section" style="margin-right: auto;">
        <h6 class="sub-title">Did you know?</h6>
        <div class="info-box" style="max-width:45ch;">
          Each color has these css classes ready to be used out-of-the-box: <br>
          <ul>
            <li>.app-(color)-text</li>
            <li>.app-(color)-border</li>
            <li>.app-(color)-bg</li>
            <li>.app-(color)-text/border/bg-hover</li>
            <li>.app-(color)-btn</li>
          </ul>
          <hr>
            For-instance:
            <ul class="list-unstyled text-center">
              <li class="app-primary-text mb-2">.app-primary-text</li>
              <li class="app-primary-border mb-2" style="border: 2px solid">.app-primary-border</li>
              <li class="app-primary-bg mb-2 app-secondary-bg-hover" style="color: white; text-shadow: 0 0 2px black;">.app-primary-bg & .app-secondary-bg-hover</li>
              <li class="app-primary-btn mb-2">.app-primary-btn</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="section ltr">
      <h2 class="title">Buttons</h2>
      <div class="sub-section container">
        @for (btn of buttons; track btn) {
          <button class="mr-4" [class]="'app-'+btn+'-btn'">.app-{{btn}}-btn</button>
        }
      </div>
    </div>
    <div class="section ltr">
      <h2 class="title">Typography</h2>
      <div class="sub-section">
        <h1>H1</h1>
        <h2>H2</h2>
        <h3>H3</h3>
        <h4>H4</h4>
        <h5>H5</h5>
      </div>
      <div class="sub-section">
        <h6 class="sub-title">Body</h6>
        <p style="max-width: 48ch;">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem eius illum iste nesciunt quo? Alias aliquam autem ea eum inventore iste magni nemo praesentium tempore vel. Blanditiis, dignissimos distinctio eveniet illum ipsam quam reiciendis unde. Alias aspernatur assumenda consequatur cum delectus, dicta doloremque eaque eum, eveniet, ex maiores non possimus quidem quisquam voluptate. Ab, accusamus animi at aut commodi cum deserunt dicta dolore doloremque dolorum ducimus eius eos est excepturi fuga hic impedit, ipsa ipsam itaque mollitia necessitatibus neque nihil numquam odio officiis porro quidem quo quod ratione rem rerum saepe tempora, ullam unde ut vel veritatis? Nisi, qui, quos.</p>
      </div>
      <div class="sub-section">
        <h6 class="sub-title">Link</h6>
        <a class="app-link">link example</a>
      </div>
    </div>
    <div class="section ltr">
      <h2 class="title">Bootstrap Theming</h2>
      <div class="sub-section row justify-content-center">
        @for (color of ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark']; track color) {
          <div class="col-auto my-3">
            <button [class]="'btn btn-'+color">.btn.btn-{{color}}</button>
          </div>
        }
        <div class="col-auto my-3">
          <button class="btn btn-link">.btn.btn-link</button>
        </div>
        <div class="w-100"></div>
        <!--<div class="col-auto my-3" *ngFor="let color of ['blue','indigo','purple','pink','red','orange','yellow','green','teal','cyan','white','gray','gray-dark']">-->
        <!--<button [style]="'border: none; color: #fff; font-weight: bold; text-shadow: 0 0 5px #000; width: 100px; height: 50px; background: '+color">{{color}}</button>-->
      <!--</div>-->
    </div>
    <div class="info-box">
      All these colors and many other bs sass variables can be changed in the <i class="highlight">web/styles/vandores/_bootstrap-vars.scss</i> file.
    </div>
  </div>
  <div class="section ltr">
    <h2 class="title">Angular Material Theming</h2>
    <div class="sub-section row align-items-center">
      <h6 class="sub-title col-12 col-lg">Primary</h6>
      <p class="col-auto"><mat-slide-toggle color="primary">primary</mat-slide-toggle></p>
      <p class="col-auto"><mat-radio-button color="primary">primary</mat-radio-button></p>
      <p class="col-auto"><mat-checkbox color="primary">primary</mat-checkbox></p>
    </div>
    <div class="sub-section row align-items-center">
      <h6 class="sub-title col-12 col-lg">Secondary/Accent</h6>
      <p class="col-auto"><mat-slide-toggle color="accent">accent</mat-slide-toggle></p>
      <p class="col-auto"><mat-radio-button color="accent">accent</mat-radio-button></p>
      <p class="col-auto"><mat-checkbox color="accent">accent</mat-checkbox></p>
    </div>
    <div class="info-box">
      Angular Material themes can be changed in the <i class="highlight">web/styles/vandores/_material-themes.scss file</i>
      <br>
        See <a href="https://material.angular.io/guide/theming">this guide</a>
      </div>
    </div>
  </div>